module.exports = __webpack_public_path__ + "static/img/jiaying-card-draw.c33d5528.png";